export default __webpack_public_path__ + "static/media/awaiting7S.561c12fb.svg";